module.exports = __webpack_public_path__ + "img/upscreen_3.d68528e4.jpg";